import React, { useContext } from "react";

import { MainProvider, MainContext } from "./Context/MainContext";

import Routes from "./Routes";

const AppContent = () => {
  const { MainState } = useContext(MainContext);
  const { useMazdaBranding } = MainState;
  
  const appClasses = [
    "App",
    useMazdaBranding ? "branding-mazda" : "",
  ].filter(Boolean).join(" ");

  return (
    <div className={appClasses}>
      <Routes />
    </div>
  );
};

function App() {
  return (
    <MainProvider>
      <AppContent />
    </MainProvider>
  );
}

export default App;
